import { Button } from '@material-ui/core';

import { FormWithDisplay } from './FormWithDisplay';

function EBTBillingInformation({ ebtCard, removeEBTCard }) {
    const handleRemoveEBTCard = () => {
        if (window.confirm('Are you sure you want to remove this billing information?')) {
            removeEBTCard();
        }
    };

    return (
        <>
            <FormWithDisplay
                formFields={[
                    {
                        name: 'card',
                        inputProps: { readOnly: true },
                        InputProps: { disableUnderline: true },
                        label: 'Card',
                        initialValue: `* * * * * * * * * * * * ${ebtCard.last4}`,
                    },
                    {
                        name: 'type',
                        inputProps: { readOnly: true },
                        InputProps: { disableUnderline: true },
                        label: 'Payment Method',
                        initialValue: 'EBT card',
                    },
                ]}
                editable={false}
            />
            <Button onClick={handleRemoveEBTCard} variant="outlined">
                REMOVE BILLING?
            </Button>
        </>
    );
}

export { EBTBillingInformation };
